import * as React from 'react';
import { DateTimePicker } from '../../../../ui-components/inputs/date-picker/date-time-picker';
import { formatOptions } from '../../../../ui-components/inputs/select/formatter';
import { Select } from '../../../../ui-components/inputs/select/select';
import { refuelEuEligibilityOptions } from '../refuel-eu-helpers';

export const refuelEuFields = (elmnt) => [
	{
		type: 'isEligible',
		title: 'Eligible',
		component: (
			<Select
				classes='NewData'
				field={elmnt.form.getField('isEligible')}
				options={formatOptions(refuelEuEligibilityOptions, false)}
			/>
		),
	},
	{
		type: 'validFrom',
		title: 'Valid from',
		component: (
			<DateTimePicker
				field={elmnt.form.getField('validFrom')}
				inputClassName='palette--c-neutral-6'
				classes='NewData'
				showTimeInput={true}
				useHour={true}
			/>
		),
	},
	{
		type: 'validTo',
		title: 'Valid to',
		component: (
			<DateTimePicker
				field={elmnt.form.getField('validTo')}
				inputClassName='palette--c-neutral-6'
				classes='NewData'
				showTimeInput={true}
				useHour={true}
			/>
		),
	},
];

export const getEligibilityLabel = (value: string) => {
	if (value === 'YES') {
		return 'Yes';
	}

	if (value === 'NO') {
		return 'No';
	}

	return value || null;
};
